import { getAppConfig } from 'app/getConfig';

export const getGTMKey = () => {
  return getAppConfig().ADMIN_UI_GTM_KEY;
};
